/** Design reference size used by App theme.scaleFactor (largest viewport side / 1400). */
export const DESIGN_WIDTH = 1400;

/** Left sidebar menu width in design units. Must match --menu-width in index.css. */
export const MENU_WIDTH_BASE = 330;

/** Space reserved for the bottom menu in design units. Must match --menu-bottom-height in index.css. */
export const MENU_BOTTOM_HEIGHT_BASE = 110;

/**
 * CSS length equivalent to `theme.scaleFactor * n` px.
 * Uses --u (100vmax / 1400) so landscape follows width and portrait follows height.
 * Pass a negative n for negative lengths (do not prefix with `-`; `-calc()` is invalid in some engines).
 */
export const u = (n: number): string => `calc(${n} * var(--u))`;

/**
 * Convert design units to CSS pixels for JS layout calculations.
 * @param n Design units
 * @returns Pixels at the current viewport size
 */
const unitsToPx = (n: number): number =>
  Math.max(window.innerWidth, window.innerHeight) * (n / DESIGN_WIDTH);

/**
 * Returns true if a CSS custom property on :root is set to something other than zero.
 * @param name Custom property name
 */
const isVarActive = (name: string): boolean => {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return Boolean(raw && raw !== "0px" && raw !== "0");
};

/**
 * Current left sidebar offset in CSS pixels (0 when the sidebar is not shown).
 */
export const getMenuOffset = (): number =>
  isVarActive("--menu-offset") ? unitsToPx(MENU_WIDTH_BASE) : 0;

/**
 * Current space reserved for the bottom menu in CSS pixels (0 when not shown).
 */
export const getMenuBottomSpace = (): number =>
  isVarActive("--menu-bottom-space") ? unitsToPx(MENU_BOTTOM_HEIGHT_BASE) : 0;
